<template>
  <component
    :is="itemComponent"
    :item="item"
    :first="first"
    :set-info-text="setInfoText"
    :item-number="itemNumber"
    :active-input-name="props.activeInputName"
  />
  <slot></slot>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { StepItem } from '@/questionnaire/types'
import InfoStepItem from '@/questionnaire/components/StepItems/InfoISteptem.vue'
import QuestionStepItem from '@/questionnaire/components/StepItems/QuestionStepItem.vue'
import HintStepItem from '@/questionnaire/components/StepItems/HintStepItem.vue'
import type { InfoItem } from '@/admin/types'

type QuestionnaireItemProps = {
  item: StepItem
  setInfoText?: ({ label: _label, info: _info, name: _name }: InfoItem, _tooltipIdentifier: string) => void
  first: boolean
  activeInputName?: string
  itemNumber?: number
}

const props = withDefaults(defineProps<QuestionnaireItemProps>(), {
  setInfoText: undefined,
  activeInputName: undefined,
  itemNumber: undefined,
})

const itemComponent = computed(() => {
  switch (props.item.item_type) {
    case 'info':
      return InfoStepItem
    case 'question':
      return QuestionStepItem
    case 'hint':
      return HintStepItem
    default:
      return null
  }
})
</script>
